export const en = {
  'shell.nav.targets': 'Targets',
  'enum.targetMetric.NEW_MEMBERSHIPS': 'New memberships',
  'enum.targetMetric.MEMBERSHIP_REVENUE': 'Membership revenue',
  'enum.targetMetric.RENEWALS': 'Renewals',
  'enum.targetMetric.PACKAGE_REVENUE': 'Package revenue',
  'enum.targetMetric.LEAD_CONVERSIONS': 'Leads turned into members',
  'enum.targetPace.MET': 'Target met',
  'enum.targetPace.AHEAD': 'Ahead of pace',
  'enum.targetPace.BEHIND': 'Behind pace',
  'enum.targetScope.GYM': 'Whole gym',
  'enum.targetScope.BRANCH': 'Branch',
  'enum.targetScope.STAFF': 'Staff member',

  'targets.title': 'Sales targets',
  'targets.description': 'Set what the gym, each branch and each staff member should sell in a month and follow how it is going against the pace.',
  'targets.add': 'Set a target',
  'targets.copy': 'Copy last month',
  'targets.copied': '{copied} copied, {skipped} already set',
  'targets.month': 'Month',
  'targets.previousMonth': 'Previous month',
  'targets.nextMonth': 'Next month',
  'targets.empty.title': 'No targets for this month',
  'targets.empty.description': 'Set a target for the whole gym, a branch or a staff member, or copy last month’s targets.',
  'targets.empty.readOnly': 'No targets have been set for this month.',
  'targets.gym': 'Gym',
  'targets.branches': 'Branches',
  'targets.people': 'Staff',
  'targets.percent': '{percent}% of target',
  'targets.pace.line': 'Expected by now: {expected} (day {elapsed} of {total})',
  'targets.pace.future': 'This month has not started',
  'targets.countedHint': 'Sales count on the day they are paid, on the gym’s calendar, less any refund. A sale counts for the person it is credited to (Sold by) and the branch that took the payment; online purchases count for nobody. The whole-gym target counts every sale of the gym, in a branch or online.',
  'targets.addTitle': 'Set a target',
  'targets.editTitle': 'Change target',
  'targets.scope': 'Target for',
  'targets.branch': 'Branch',
  'targets.staffMember': 'Staff member',
  'targets.gymHint': 'Counts every sale of the gym, whether made in a branch or online.',
  'targets.choose': 'Choose…',
  'targets.metric': 'What to count',
  'targets.valueMoney': 'Target amount ({currency})',
  'targets.valueCount': 'Target number',
  'targets.currently': 'Now {value}',
  'targets.created': 'Target set',
  'targets.updated': 'Target changed',
  'targets.removed': 'Target removed',
  'targets.removeTitle': 'Remove this target?',
  'targets.removeDescription': 'The “{metric}” target for {subject} will be removed. Sales are not affected.',
  'targets.mine.title': 'My targets',
  'targets.soldBy': 'Sold by',
  'targets.soldByHint': 'Counts towards this person’s targets.',
  'targets.soldByMe': '{name} (me)',
  'targets.soldByNobody': 'Nobody',

  'reports.dataset.sales': 'Sales',
  'reports.grouping.branch': 'Branch',
  'reports.measure.revenue': 'Revenue',
  'reports.measure.sales': 'Sales',
  'reports.measure.averageSale': 'Average sale',
  'reports.onlineSales': 'Online',
  'reports.builtIn.salesByStaff': 'Sales by staff member',

  'admin.apiError.SELLER_NOT_ALLOWED': 'A sale can be credited only to active staff of this gym.',
  'admin.apiError.NOT_A_SALE': 'Only a payment for a membership or a package can be credited to someone.',
  'admin.apiError.TARGET_EXISTS': 'That target is already set for this month.',
};

export const ka: Record<keyof typeof en, string> = {
  'shell.nav.targets': 'მიზნები',
  'enum.targetMetric.NEW_MEMBERSHIPS': 'ახალი აბონემენტები',
  'enum.targetMetric.MEMBERSHIP_REVENUE': 'აბონემენტების შემოსავალი',
  'enum.targetMetric.RENEWALS': 'განახლებები',
  'enum.targetMetric.PACKAGE_REVENUE': 'პაკეტების შემოსავალი',
  'enum.targetMetric.LEAD_CONVERSIONS': 'წევრად ქცეული ლიდები',
  'enum.targetPace.MET': 'მიზანი შესრულებულია',
  'enum.targetPace.AHEAD': 'ტემპს უსწრებს',
  'enum.targetPace.BEHIND': 'ტემპს ჩამორჩება',
  'enum.targetScope.GYM': 'მთელი დარბაზი',
  'enum.targetScope.BRANCH': 'ფილიალი',
  'enum.targetScope.STAFF': 'თანამშრომელი',

  'targets.title': 'გაყიდვების მიზნები',
  'targets.description': 'განსაზღვრეთ, რა უნდა გაყიდოს თვეში დარბაზმა, თითოეულმა ფილიალმა და თანამშრომელმა, და თვალი ადევნეთ, რამდენად ასწრებენ ტემპს.',
  'targets.add': 'მიზნის დაწესება',
  'targets.copy': 'წინა თვის კოპირება',
  'targets.copied': 'დაკოპირდა: {copied}, უკვე დაწესებული იყო: {skipped}',
  'targets.month': 'თვე',
  'targets.previousMonth': 'წინა თვე',
  'targets.nextMonth': 'შემდეგი თვე',
  'targets.empty.title': 'ამ თვისთვის მიზნები არ არის',
  'targets.empty.description': 'დააწესეთ მიზანი მთელი დარბაზისთვის, ფილიალისთვის ან თანამშრომლისთვის, ან დააკოპირეთ წინა თვის მიზნები.',
  'targets.empty.readOnly': 'ამ თვისთვის მიზნები არ არის დაწესებული.',
  'targets.gym': 'დარბაზი',
  'targets.branches': 'ფილიალები',
  'targets.people': 'თანამშრომლები',
  'targets.percent': 'მიზნის {percent}%',
  'targets.pace.line': 'ამ დროისთვის მოსალოდნელია: {expected} (თვის {total} დღიდან გავიდა {elapsed})',
  'targets.pace.future': 'ეს თვე ჯერ არ დაწყებულა',
  'targets.countedHint': 'გაყიდვა ითვლება გადახდის დღეს, დარბაზის კალენდრით, დაბრუნებული თანხის გამოკლებით. ის ეწერება იმ თანამშრომელს, ვისაც მიეკუთვნა („გამყიდველი“), და ფილიალს, სადაც თანხა მიიღეს; ონლაინ შეძენა არავის ეწერება. მთელი დარბაზის მიზანში ითვლება დარბაზის ყველა გაყიდვა, როგორც ფილიალებში, ისე ონლაინ.',
  'targets.addTitle': 'მიზნის დაწესება',
  'targets.editTitle': 'მიზნის შეცვლა',
  'targets.scope': 'ვისთვის არის მიზანი',
  'targets.branch': 'ფილიალი',
  'targets.staffMember': 'თანამშრომელი',
  'targets.gymHint': 'ითვლის დარბაზის ყველა გაყიდვას, როგორც ფილიალში, ისე ონლაინ გაკეთებულს.',
  'targets.choose': 'აირჩიეთ…',
  'targets.metric': 'რა უნდა ჩაითვალოს',
  'targets.valueMoney': 'მიზნის თანხა ({currency})',
  'targets.valueCount': 'მიზნის რაოდენობა',
  'targets.currently': 'ამჟამად: {value}',
  'targets.created': 'მიზანი დაწესდა',
  'targets.updated': 'მიზანი შეიცვალა',
  'targets.removed': 'მიზანი წაიშალა',
  'targets.removeTitle': 'წაიშალოს ეს მიზანი?',
  'targets.removeDescription': 'მიზანი „{metric}“ — {subject} — წაიშლება. გაყიდვები არ შეიცვლება.',
  'targets.mine.title': 'ჩემი მიზნები',
  'targets.soldBy': 'გამყიდველი',
  'targets.soldByHint': 'ჩაეთვლება ამ თანამშრომლის მიზნებს.',
  'targets.soldByMe': '{name} (მე)',
  'targets.soldByNobody': 'არავინ',

  'reports.dataset.sales': 'გაყიდვები',
  'reports.grouping.branch': 'ფილიალი',
  'reports.measure.revenue': 'შემოსავალი',
  'reports.measure.sales': 'გაყიდვები',
  'reports.measure.averageSale': 'საშუალო გაყიდვა',
  'reports.onlineSales': 'ონლაინ',
  'reports.builtIn.salesByStaff': 'გაყიდვები თანამშრომლების მიხედვით',

  'admin.apiError.SELLER_NOT_ALLOWED': 'გაყიდვა მხოლოდ ამ დარბაზის აქტიურ თანამშრომელს შეიძლება ჩაეწეროს.',
  'admin.apiError.NOT_A_SALE': 'გამყიდველის მითითება შეიძლება მხოლოდ აბონემენტის ან პაკეტის გადახდისთვის.',
  'admin.apiError.TARGET_EXISTS': 'ეს მიზანი ამ თვისთვის უკვე დაწესებულია.',
};
